exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'warp';\n  src: url(" + require("../../../assets/font/font.ttf") + ");\n}\ndiv.content .content > p:first-of-type {\n  margin-top: 30px;\n}\n.inlineLink {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.qualiOLinks {\n  text-align: center;\n}\n.qualiOLinks div.qualiImg {\n  display: inline-block;\n  max-width: 601px;\n  margin: auto;\n  margin: 0 30px;\n}\n.qualiOLinks div.qualiImg img.control {\n  box-shadow: -8px 10px 17px 0px rgba(0, 0, 0, 0.62);\n  border-radius: 15px;\n  cursor: pointer;\n}\ndiv.overlay {\n  position: fixed;\n  z-index: 99999999999999999;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(220, 220, 255, 0.5);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\ndiv.overlay app-compare-slider,\ndiv.overlay app-three-sixty-view {\n  margin: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/artur/workspace/vscode/warpriders/src/app/content/home/home.component.less
// module id = ../../../../../src/app/content/home/home.component.less
// module chunks = 1